import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'motion/react';
import '../../../EscapeHandlerStack/EscapeHandlerStack.js';
import { useStackedHandleOnEscape } from '../../../EscapeHandlerStack/hooks/use-stacked-handle-on-escape.js';
import { FocusTrap } from '../../../FocusTrap/FocusTrap.js';
import { lockScroll, unlockScroll } from '../../../Util/scroll-lock.js';
import '@swc/helpers';
import 'lodash/uniq';
import '@grandvisionhq/utils';
import '../../../MediaQuery/MediaQueryContext.js';
import '../../../Util/get-donation-foundation-icon.js';
import { useDrawer } from '../../context/DrawerContext.js';

/** These variants are a mirror of the ones used in the Site Nav.
 * The Site Navigation overlay moves into the screen from the left,
 * the Drawer moves into the screen from the right. */ const transition = {
    ease: 'easeInOut',
    duration: 0.3
};
const verticalOverlayVariants = {
    open: {
        x: '0',
        y: '0',
        transition
    },
    closed: {
        y: '0',
        x: '100%',
        transition
    }
};
const horizontalOverlayVariants = {
    open: {
        y: '0',
        x: '0',
        transition
    },
    closed: {
        y: '100%',
        x: '0',
        transition
    }
};
const DrawerOverlay = ({ children , 'data-t': dataT , shouldMountContent =false , disableInitialFocus =false ,  })=>{
    const { isOpen , close , direction  } = useDrawer();
    React.useEffect(()=>{
        if (isOpen) {
            lockScroll();
            return ()=>unlockScroll()
            ;
        }
    }, [
        isOpen
    ]);
    useStackedHandleOnEscape({
        isOpen,
        handler: close
    });
    const isActive = shouldMountContent || isOpen;
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, isActive && /*#__PURE__*/ React.createElement(FocusTrap, {
        active: isOpen,
        focusTrapOptions: {
            clickOutsideDeactivates: true,
            initialFocus: disableInitialFocus ? false : undefined
        }
    }, /*#__PURE__*/ React.createElement(motion.div, {
        "data-t": dataT,
        role: "dialog",
        key: "drawer-overlay",
        className: classnames('drawer-overlay', `drawer-overlay--${direction}`),
        variants: direction === 'bottom' ? horizontalOverlayVariants : verticalOverlayVariants,
        animate: isOpen ? 'open' : 'closed',
        // reason: inert property lets us prevent tab focus on this element and its children
        // @ts-expect-error inert is not a property react supports yet
        inert: !isOpen ? '' : undefined,
        "aria-hidden": !isOpen,
        initial: "closed",
        exit: "closed"
    }, children)));
};

export { DrawerOverlay };
//# sourceMappingURL=DrawerOverlay.js.map
